import { getQuestionnaireBySubjectID } from "../apiCalls.js";

export const fetchQuestionnaireBySubjectID = async (
  selectedUser,
  setQuestionnaireData
) => {
  try {
    const questionnaireDt = await getQuestionnaireBySubjectID(selectedUser);
    const filteredQuestionnaire = questionnaireDt.filter((item) =>
      [
        "NUTRITION", "MET_HOURS", "HEALTH_LIFESTYLE", "SOCIOECONOMIC",  // Legacy codenames
        "Nutrition", "MetabolicHours", "Health-Lifestyle", "SF",         // Current codenames
      ].includes(item.questionnaireCodename)
    );
    // console.log("questionnaireDt", questionnaireDt);

    setQuestionnaireData(filteredQuestionnaire);
  } catch (error) {
    console.error("Error when fetching questionnaire", error);
  }
};

export const fetchUseInfoFromQuestionnaires = async (
  selectedUser,
  setBasicDataFromQuestionnaires
) => {
  try {
    const questionnaireDt = await getQuestionnaireBySubjectID(selectedUser);
    // console.log("questionnaireDt", questionnaireDt);

    // Map questionCodename to a stable key for display, supporting both old and new question IDs
    const questionCodeToKey = {
      // New question codenames (current NELI questionnaires)
      "COUNTRY": "country",
      "Ethnicity": "ethnicity",
      "Colorectal_cancer": "familyHistoryCRC",
      "Smoker": "smoking",
      "Former_smoker": "formerSmoker",
      "REGION": "environmentType",
      "HOUSING": "housing",
      "OCCUPATION": "occupation",
      "EMPLOYMENT": "employment",
    };

    // Old question_id to key mapping (legacy data)
    const oldQuestionIdToKey = {
      11430: "country",
      12867: "ethnicity",
      12868: "familyHistoryCRC",
      12874: "smoking",
      12875: "formerSmoker",
      11343: "environmentType",
      11344: "housing",
      11345: "occupation",
      11346: "employment",
    };

    const relevantCodenames = Object.keys(questionCodeToKey);
    const relevantOldIds = Object.keys(oldQuestionIdToKey).map(Number);

    const filteredQuestionnaireDataForTable = questionnaireDt.filter(
      (item) =>
        relevantCodenames.includes(item.questionCodename) ||
        relevantOldIds.includes(item.question_id)
    );

    const newBasicUserInfo = filteredQuestionnaireDataForTable.reduce(
      (acc, item) => {
        const key =
          questionCodeToKey[item.questionCodename] ||
          oldQuestionIdToKey[item.question_id];
        if (key && !acc[key]) {
          acc[key] = item.answer;
        }
        return acc;
      },
      {}
    );

    setBasicDataFromQuestionnaires(newBasicUserInfo);
  } catch (error) {
    console.error("Error when fetching questionnaire", error);
  }
};
